import { CurationActionTypeEnum, unsupportedActionTypes } from '../../api/agents/models/curation-agent.api';

/**
 * Groupings the panel uses to decide which picker an action type needs. The types themselves live
 * with the API contract, as CurationActionTypeEnum.
 */

/** Offered in the Action Type dropdown, in the order the spec lists them */
export const selectableActionTypes: CurationActionTypeEnum[] = [
    CurationActionTypeEnum.saveToAccount,
    CurationActionTypeEnum.saveToFolder,
    CurationActionTypeEnum.saveToTag,
    CurationActionTypeEnum.deleteFromAccount,
    CurationActionTypeEnum.removeFromFolder,
    CurationActionTypeEnum.removeFromTag,
    CurationActionTypeEnum.generateInsight,
    CurationActionTypeEnum.sendToRss
].filter(type => !unsupportedActionTypes.includes(type));

/** Action types an outcome can hold only once - a second one would only repeat the first */
export const singleUseActionTypes: CurationActionTypeEnum[] = [
    CurationActionTypeEnum.saveToAccount,
    CurationActionTypeEnum.deleteFromAccount
];

/** Action types configured by picking one or more folders */
export const folderActionTypes: CurationActionTypeEnum[] = [
    CurationActionTypeEnum.saveToFolder,
    CurationActionTypeEnum.removeFromFolder
];

/** Action types configured by picking one or more tags */
export const tagActionTypes: CurationActionTypeEnum[] = [
    CurationActionTypeEnum.saveToTag,
    CurationActionTypeEnum.removeFromTag
];

/**
 * Action types that put the mention on the account. Saving to a folder or a tag, and generating an
 * insight, all save the mention itself as a side effect, so they imply the same outcome banner.
 */
export const savesToAccountActionTypes: CurationActionTypeEnum[] = [
    CurationActionTypeEnum.saveToAccount,
    CurationActionTypeEnum.saveToFolder,
    CurationActionTypeEnum.saveToTag,
    CurationActionTypeEnum.generateInsight
];
